export default __webpack_public_path__ + "static/media/style_squares.2b5b7536.png";